export const REFERRED_BY_OPTIONS = [
  'Social Media',
  'Friend or Family',
  'Website',
  'Walk-in',
  'Education Fair',
  'School / College',
  'Advertisement',
  'Other',
];

/** Sources that require the Referred By (Name) field. Includes legacy "Person Name". */
export const REFERRED_BY_NAME_TRIGGERS = [
  'Friend or Family',
  'Other',
  'Person Name',
];

export const requiresReferredByName = (referredBy) =>
  REFERRED_BY_NAME_TRIGGERS.includes(String(referredBy || '').trim());

const LEGACY_SOURCE_INQUIRY_MAP = {
  website: 'Website',
  referral: 'Friend or Family',
  'social-media': 'Social Media',
  advertisement: 'Advertisement',
  'walk-in': 'Walk-in',
  other: 'Other',
};

/** Map old slug values to current Referred By labels. */
export const normalizeSourceInquiry = (value) => {
  if (!value) return '';
  return LEGACY_SOURCE_INQUIRY_MAP[value] || value;
};
